// mocks
const box =
  "w-[24px] h-[24px] rounded-[4px] flex justify-center items-center cursor-pointer";
const activeBox = "bg-white";

const mock = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export { box, activeBox, mock };
